export default __webpack_public_path__ + "static/media/interior_virtual_sales_office.a923cc87.png";